import React, { useEffect, useState } from "react";
import "./loan-step.css";
import { FaUserEdit, FaCheckCircle, FaMoneyBillWave, FaPaperPlane } from "react-icons/fa";

const stepsData = [
  {
    icon: <FaUserEdit />,
    title: "1. Basic Application",
    description: "Fill out the simple, 3-minute application form with your personal details.",
    color: "#000000",
  },
  {
    icon: <FaPaperPlane />,
    title: "2. Document Submission",
    description: "Securely upload necessary documents online for instant verification.",
    color: "#000000",
  },
  {
    icon: <FaCheckCircle />,
    title: "3. Quick Approval",
    description: "Receive instant decision and finalize the loan offer details.",
    color: "#000000",
  },
  {
    icon: <FaMoneyBillWave />,
    title: "4. Instant Funds",
    description: "Funds are immediately disbursed to your bank account.",
    color: "#000000",
  },
];

const LoanSteps = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % stepsData.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ls-wrap">
      <div className="ls-container">
        <div className="ls-eyebrow">4 Simple Steps</div>

        <h2 className="ls-title">
          Your <span className="ls-highlight">Instant Loan</span> Process
        </h2>

        <p className="ls-sub">
          Getting quick cash is easy. Follow these four simple steps and get funded today.
        </p>

        <div className="ls-stepper-container">
          <div className="ls-progress-bar-wrap">
            <div
              className="ls-progress-bar"
              style={{
                width: `${(currentStep / (stepsData.length - 1)) * 100}%`,
              }}
            ></div>
          </div>

          <div className="ls-steps-row">
            {stepsData.map((step, index) => (
              <div
                key={index}
                className={`ls-step-item ${
                  index <= currentStep ? "completed" : ""
                } ${index === currentStep ? "active" : ""}`}
                style={{ "--step-color": step.color }}
              >
                <div className="ls-step-circle">
                  <div className="ls-icon">{step.icon}</div>
                </div>

                <div className="ls-step-content">
                  <h3 className="ls-step-title">{step.title}</h3>
                  <p className="ls-step-desc">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanSteps;
